import { GetStaticProps } from 'next';
import Head from 'next/head';
import DisclaimerComponent from '../src/components/Disclaimer';
import { getCanonicalUrl } from '../src/utils/seoHelpers';
import { seoConfig } from '../src/config/seo.config';

export default function TermsPage() {
  const pageTitle = "Terms & Conditions - TurfBooking.in";
  const pageDescription = "Read TurfBooking.in's Terms and Conditions. Understand your rights and responsibilities when using our sports turf booking platform.";
  const canonicalUrl = getCanonicalUrl('/terms');
  const baseUrl = seoConfig.baseUrl;

  return (
    <>
      <Head>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta name="keywords" content="turfbooking terms, terms of service, booking conditions, user agreement" />
        <link rel="canonical" href={canonicalUrl} />
        
        {/* Open Graph */}
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:image" content={`${baseUrl}/TBlogo.png`} />
        
        {/* Twitter */}
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        
        {/* Prevent indexing of legal pages (optional, but common practice) */}
        <meta name="robots" content="noindex, follow" />
      </Head>
      <DisclaimerComponent />
    </>
  );
}

// Converted to getStaticProps for static generation at build time
// This improves performance by pre-rendering the page instead of SSR on every request
export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
  };
};
